import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {ChargedActModel} from '../../../api/entity/chargedAct.model';
import {ChargedActConverter} from '../../../api/entity/converter/chargedAct.converter';
import {ChargedActDataService} from './chargedActData.service';

@Injectable({ providedIn: 'root' })
export class ChargedActDataServiceAdapter extends AbstractDataServiceDtoAdapter<ChargedActModel, ChargedActConverter> {
    constructor(dataService: ChargedActDataService, converter: ChargedActConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ChargedActModel {
        return new ChargedActModel();
    }
}
